if (!customElements.get('selene-navigation')) {
  customElements.define('selene-navigation', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-sx-open]');
      if (dialog && trigger) {
        const close = () => dialog.close();
        trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); }, options);
        this.querySelector('[data-sx-close]').addEventListener('click', close, options);
        dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }, options);
        dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } }, options);
      }
      document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(d => d.open = false); }, options);
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !dialog?.open) this.querySelectorAll('details[open]').forEach(d => { d.open = false; d.querySelector('summary')?.focus(); }); }, options);
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
}
if (!customElements.get('selene-market')) {
  customElements.define('selene-market', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort(); this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      const details = this.querySelector('details');
      const close = () => { details.open = false; details.querySelector('summary').focus(); };
      this.querySelector('[data-sx-market-close]').addEventListener('click', close, options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') close(); }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) details.open = false; }, options);
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
}
